// @ts-check
/**
 * @description Disable form submit on pressing enter key
 * @param {string} formId - The form id or form css class
 * @returns {void}
 */
export const formDisableSubmitOnEnter = (formId) => {
    
    if (formId.length === 0 && formId === null) return;

    const form = document.querySelector(formId);
    
    if (form) {
        form.addEventListener('keydown', function (event) {
            const keyboardEvent = /** @type {KeyboardEvent} */ (event);
            if (keyboardEvent.key === 'Enter') {
                event.preventDefault();
            }
        });
    }
};

/**
 * @description Handle form submit to avoid dubble click
 * @param {object} formElements - The form css class, id, element classes, ids or just plain elements
 *  Example:
 *  {
 *      form: '.EPiServerForms',
 *      container: '.articlePageEpiForm',
 *      submitButton: '.FormSubmitButton',
 *   }
 * @returns {void}
 */
export const formPreventMultipleSubmit = (formElements) => {
    const formObject = document.querySelectorAll(formElements.form);

    if (formObject.length === 0) return;

    let isSubmitting = false;

    formObject.forEach((form) => {
        form.addEventListener('submit', () => {
            const formContainer = document.querySelector(formElements.container);

            if (!formContainer || isSubmitting) return;

            const submitButton = formContainer.querySelector(formElements.submitButton);

            if (submitButton) {
                submitButton.disabled = true;
            }

            isSubmitting = true;
        });
    });
};
